const BOX_BORDER = "1px solid #e6e6e6";
const BORDER_RADIUS = "10px";

const obj = {
  maxWidth: "935px",
  bgColor: "#FAFAFA",
  lightVioletColor: "rgba(229,233,255,0.3)",
  darkVioletColor: "#3F0099",
  blackColor: "#262626",
  darkGreyColor: "#5F6368",
  lightGreyColor: "#c7c7c7",
  redColor: "#ED4956",
  blueColor: "#3897f0",
  darkBlueColor: "#003569",
  boxBorder: "1px solid #e6e6e6",
  borderRadius: "4px",
  whiteBox: `border:${BOX_BORDER};
             border-radius:${BORDER_RADIUS};
             background-color:white;
            `,
  breakpoints: {
    mobile: "480px",
    tablet: "768px",
  },
};

export default obj;
